module.exports = __webpack_public_path__ + "media/assets/close-01105fcd3d94168d7cc72dd38e05cce9e39aea0c5dda12b69ffc33cf367a866d.svg";